/* unplugin-vue-components disabled */import script from "./StatsConfigEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./StatsConfigEditor.vue?vue&type=script&setup=true&lang=js"

import "./StatsConfigEditor.vue?vue&type=style&index=0&id=2e3d35ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e3d35ea"]])

export default __exports__